import * as React from "react";
import MuiCircularProgress from "@mui/material/CircularProgress";


const PageLoader = () => {
	return (
		<div style={{ display: "flex", justifyContent: "space-around", marginTop: 350 }}>
			<MuiCircularProgress />
		</div>
	)
}



export default PageLoader;